<section class="content">
  <div class="container-fluid">
    <div class="block-header">
      <div class="row">
        <div class="col-xs-11 col-sm-11 col-md-11 col-lg-11">
          <ul class="breadcrumb breadcrumb-style">
            <li class="breadcrumb-item">
              <h4 class="page-title">Change Password</h4>
            </li>
            <li
              *ngIf="currentUser.UserRoleId !=2"
              class="breadcrumb-item bcrumb-1"
            >
              <a routerLink="/pharmacist/dashboard">
                <i class="fas fa-home"></i> Home</a
              >
            </li>
            <li
              *ngIf="currentUser.UserRoleId ==2"
              class="breadcrumb-item bcrumb-1"
            >
              <a routerLink="/doctor/dashboard">
                <i class="fas fa-home"></i> Home</a
              >
            </li>
            <li class="breadcrumb-item active">Change Password</li>
          </ul>
        </div>
        <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1">
          <a
            (click)="goBack()"
            class="btn btn-group-lg btn-outline-secondary float-end"
          >
            <i class="fa fa-angle-left"></i> Back
          </a>
        </div>
      </div>
    </div>
    <div class="row clearfix">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
        <div class="card">
          <!-- <div class="header">
            <h2>Change Password</h2>
          </div> -->
          <div class="body">
            <div class="col-sm-5 m-auto auth-form-section">
              <div class="form-section">
                <div class="auth-wrapper">
                  <h2 [hidden]="hideChangePasswordForm" class="welcome-msg">
                    Change Password
                  </h2>

                  <p
                    [hidden]="hideChangePasswordForm"
                    class="auth-signup-text text-muted"
                  >
                    Let Us Help You
                  </p>
                  <!--  -->
                  <div class="mt-5" [hidden]="isOldPasswordVerify">
                    <form
                      autocomplete="off"
                      [formGroup]="oldPasswordConfirmForm"
                      (ngSubmit)="validateOldPassword()"
                    >
                      <div class="row">
                        <div
                          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-3"
                        >
                          <mat-form-field
                            class="example-full-width"
                            appearance="outline"
                          >
                            <mat-label>Old Password</mat-label>
                            <input
                              matInput
                              formControlName="oldpassword"
                              [type]="ohide ? 'password' : 'text'"
                              required
                              [maxLength]="15"
                            />
                            <mat-icon matSuffix (click)="ohide = !ohide">
                              {{ ohide ? "visibility_off" : "visibility"
                              }}</mat-icon
                            >
                            <mat-error
                              *ngIf="
                                oldPasswordConfirmForm
                                  .get('oldpassword')
                                  .hasError('required')
                              "
                            >
                              Old Password is required
                            </mat-error>
                            <mat-error
                              *ngIf="
                              oldPasswordConfirmForm.controls.oldpassword?.errors?.pattern && !oldPasswordConfirmForm.get('oldpassword').hasError('required')
                            "
                            >
                              Password is invalid
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div class="container-auth-form-btn mb-4">
                          <div class="row">
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                              <button
                                class="btn btn-lg btn-primary w-100"
                                type="submit"
                              >
                                Next
                              </button>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                              <button
                                class="btn btn-lg btn-secondary w-100"
                                type="button"
                                (click)="goBack()"
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <!--  -->
                  <div
                    class="mt-5"
                    *ngIf="hideChangePasswordForm && !IsSuccess"
                  >
                    <form
                      autocomplete="off"
                      [formGroup]="changePasswordForm"
                      (ngSubmit)="confirmChangePassword()"
                    >
                      <div class="row">
                        <div
                          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-3"
                        >
                          <mat-form-field
                            class="example-full-width"
                            appearance="outline"
                          >
                            <mat-label>New Password</mat-label>
                            <input
                              matInput
                              formControlName="newpassword"
                              [type]="nhide ? 'password' : 'text'"
                              [pattern]="constants.PASSWORD_REGEXP"
                              required
                              [maxLength]="15"
                            />
                            <mat-icon matSuffix (click)="nhide = !nhide">
                              {{ nhide ? "visibility_off" : "visibility"
                              }}</mat-icon
                            >
                            <mat-error
                              *ngIf="
                                changePasswordForm
                                  .get('newpassword')
                                  .hasError('required')
                              "
                            >
                              New Password is required
                            </mat-error>
                            <mat-error
                              *ngIf="changePasswordForm.controls.newpassword?.errors?.pattern"
                            >
                              New Password is invalid
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div
                          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-3"
                        >
                          <mat-form-field
                            class="example-full-width"
                            appearance="outline"
                          >
                            <mat-label>Confirm New Password</mat-label>
                            <input
                              matInput
                              formControlName="cpassword"
                              [type]="chide ? 'password' : 'text'"
                              required
                              (change)="checkPassword()"
                              [maxLength]="15"
                              [errorStateMatcher]="errorMatcher"
                            />
                            <mat-icon matSuffix (click)="chide = !chide">
                              {{ chide ? "visibility_off" : "visibility"
                              }}</mat-icon
                            >
                            <mat-error
                              *ngIf="!checkPassword() && 
                                changePasswordForm
                                  .get('cpassword')
                                  .hasError('required')
                              "
                            >
                              New Password is required
                            </mat-error>
                            <!-- <mat-error
                              *ngIf="changePasswordForm.controls.cpassword?.errors?.pattern"
                            >
                              Confirm Password is invalid
                            </mat-error> -->
                            <!-- <mat-error
                              *ngIf="changePasswordForm.hasError('passwordsDoNotMatch')"
                            >
                              Passwords do not match!
                            </mat-error> -->
                          </mat-form-field>
                          <mat-error
                            style="
                              color: #f44336;
                              font-size: 75%;
                              text-align: left;
                              padding-left: 13px;
                              margin-top: -5px;
                            "
                            *ngIf="!checkPassword() && !changePasswordForm.get('cpassword').hasError('required')"
                          >
                            Password mismatch
                          </mat-error>
                        </div>
                        <div class="container-auth-form-btn mb-4">
                          <div class="row">
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                              <button
                                class="btn btn-lg btn-primary w-100"
                                type="submit"
                              >
                                Save
                              </button>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                              <button
                                class="btn btn-lg btn-secondary w-100"
                                type="button"
                                (click)="gotoDashboard()"
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                  <div *ngIf="IsSuccess" class="reset-password-success mt-5">
                    <div class="row align-center">
                      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-1">
                        <mat-icon class="fa-6x text-success"
                          >verified_user</mat-icon
                        >
                      </div>
                      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-3">
                        <h1 class="text-success">Success!</h1>
                        <h4 class="text-dark">Password Change Successful</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
